import { Header } from './Header';
import { useState, useEffect } from 'react';
import { Form, Input, Row, Col, Button, message, notification, Modal, Spin } from 'antd';
import {api} from '../helper/axios/index'
import { ArrowRightOutlined , ArrowLeftOutlined} from '@ant-design/icons';
import { Password } from './Password';


export const Profil = () =>{

    const [apis, contextHolder] = notification.useNotification();

    const [api2, contextHolder2] = notification.useNotification();
    
    const openNotificationWithIconS = () => {
      api2['success']({
        message: '',
        description:
          "Le mot de passe a été modifier avec succèss",
      });
    };

  const openNotificationWithIcon = () => {
    apis['success']({
      message: '',
      description:
        "Les données du profil ont été modifié avec succèss",
    });
  };


    const [menuActive, setMenuActive] = useState(false);

    const handleMenuClick = () => {
      setMenuActive(prevState => !prevState);
    };

    const ENDPOINT ="tax-payer"

    const [mesData, setmesData] = useState({});
const [mesDonnee, setmesDonnee] = useState({});
const [loading, setloading] = useState(false)

useEffect(() => {  
    fetchData();
}, []);

const fetchData = async () => {
    try {  
        const response = await api.get(`${ENDPOINT}/${utilisateurs.taxPayer.id}`);
        console.log(response.data);
        setmesData(response.data);
        setChargement(false)
    } catch (error) {
        console.error("Erreur lors de la récupération du profil :", error);
    }
}

useEffect(() => {
    if (mesData.folder && mesData.folder.length > 0) {
        console.log(mesData.folder[0]);
        setmesDonnee(mesData.folder[0]);
    } else {
        console.log("Le tableau mesData.folder est vide ou non défini.");
    }
}, [mesData]);

console.log(mesDonnee);


   
    const utilisateurs = JSON.parse(sessionStorage.getItem("utilisateurs"))?.user

    const [mesValeurs, setmesValeurs]= useState({
        first_name: utilisateurs.profil.first_name,
        last_name: utilisateurs.profil.last_name,
        email: utilisateurs.profil.email,
        phone: utilisateurs.profil.phone.slice(4),
        adress: utilisateurs.taxPayer.adress,
        localite: utilisateurs.taxPayer.localite,
        civiliter: utilisateurs.taxPayer.civiliter
    })

    console.log("mes data oui data :", mesValeurs)

    console.log(utilisateurs)

   

    const initialValues = {
        ...mesValeurs,
        ...utilisateurs.taxPayer.folder
      };

      const onFinish = async (values) => {
        const taxPayer = {
            adress: values.adress,
            localite: values.localite
        }
        const user = {
        id: utilisateurs.id,
        first_name: values.first_name,
        last_name:values.last_name,
        phone: values.phone,
        email: values.email,
        // civiliter: values.civiliter
        }

        setloading(true)

       await handleAdd(taxPayer,user);
      };

     

      const handleAdd = async (taxPayer,user) => {
        try {
            const contient = user.phone;
            if(contient.startsWith('+242')){
              user.phone= user.phone
            }else{
              user.phone = "+242"+user.phone
            }
            const data = {
                user: user,
                taxPayer: taxPayer,
              };
          const response =  await api.patch(`${ENDPOINT}/${utilisateurs.taxPayer.id}`, data);
          console.log('Réponse du serveur:', response.data);
          utilisateurs.profil = user;
          sessionStorage.setItem("utilisateurs", JSON.stringify({ user: utilisateurs }));
          setloading(false)
          openNotificationWithIcon()
        } catch (error) {
            console.log(error)
                for(let i=0; i<error?.response?.data?.errors?.user?.errors_list.length; i++){
                    console.log(error?.response?.data?.errors?.user?.errors_list[i]);
                    message.error(error?.response?.data?.errors?.user?.errors_list[i]);
                }
        }
      };

      const [resetKey, setResetKey] = useState(0);
      const [OuvreDate, setOuvreDate] = useState(null)

      const handleResetDate = () => {
        setOuvreDate(false);
        // setloadingDate(false)
        setResetKey((prevKey) => prevKey + 1);
      };
      const [loadingDate, setloadingDate] = useState(false)
      const ENDPOINT2 = "user/updatePassword?="
      const handleUpdateDate = async (values) =>{
        setloadingDate(true)
        try {
          const reponse = await api.post(`${ENDPOINT2}${utilisateurs.id}`, values);
          console.log(reponse)
          setloadingDate(false)
          setResetKey((prevKey) => prevKey + 1);
          setOuvreDate(false)
          openNotificationWithIconS()
        } catch (error) {
         console.log("erreur : ", error)
          setloadingDate(false)
          // toastError()
        }
      }

      const handleOuvre = ()=>{
        setOuvreDate(true)
      }

      const [Chargement, setChargement]= useState(true)
    return(
        <>
        {contextHolder} {contextHolder2}

         <Header menuActive={menuActive} handleMenuClick={handleMenuClick} />
         <div className="main-banner wow fadeIn" id="top" data-wow-duration="1s" data-wow-delay="0.5s">
       <div className="container" style={{marginTop: "-5em"}}>
      <div className="row">
        <div className="col-lg-12  shadow p-5">  
            <h2 style={{color: "#FE3F40"}} className="mb-5">Mon profil</h2>
            <h2 style={{color: "#03A4ED"}} className='mb-3'>Informations Personnelles</h2>
            <Form  onFinish={onFinish} initialValues={initialValues} layout="vertical">
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item label="Prénom" name="first_name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Nom" name="last_name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item label="Email" name="email" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Téléphone" name="phone" rules={[{ required: true }]}>
            <Input addonBefore="+242" type="number" style={{ width: '100%'}}/>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item label="Localité" name="localite" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Adresse" name="adress" rules={[{ required: true }]}>
            <Input.TextArea rows={4} style={{ width: '100%', height: '20px', overflow: "hidden" }} />
          </Form.Item>
        </Col>
        {/* <Col span={12}>
          <Form.Item label="Civilité" name="civiliter" rules={[{ required: true }]}>
          <Input />
          </Form.Item>
        </Col> */}
      </Row>
      <div className="d-flex justify-content-between" >
      <Button
         style={{background: '#6C63FF',display: "flex", alignItems:"center", justifyContent: "center"}}
        type="primary" onClick={handleOuvre}>
          Mettre à jour le mot de passe
        </Button>

        <Button icon={<ArrowRightOutlined />}
         style={{background: '#6C63FF', width: "12em",display: "flex", alignItems:"center", justifyContent: "center"}}
        type="primary" loading={loading} htmlType="submit">
          Modifier
        </Button>
      </div>
    </Form>

    <Modal
                title={"Mettre à jour le mot de passe"}
                centered
                onCancel={handleResetDate}
                open={OuvreDate}
                width={500}
                footer={null}
              >
                <Password handleResetDate={handleResetDate} resetKey={resetKey} loadingDate={loadingDate} handleUpdateDate={handleUpdateDate}/>
        </Modal>
        <h2 style={{color: "#03A4ED"}} className='mb-3 mt-3'>Informations du Dossier</h2>
        {Chargement?(
           <div className="d-flex justify-content-center align-items-center" >
           <div className="text-center">
         <Spin spinning={Chargement} size="large" />
         <p style={{ marginTop: "10px", fontSize:"20px"}}>
         Chargement des données...
         </p>
     </div>
     </div>
        ):( <Form initialValues={initialValues}  layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item  label="Nom de l'entreprise" >
              <Input value={mesDonnee.title} disabled/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Description de l'entreprise" >
              <Input value={mesDonnee.describe} disabled/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label="Numéro d'identification unique (NIU)">
              <Input value={mesDonnee.niu} disabled/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Chiffre d'affaire" >
              <Input value={mesDonnee.businessStat}  disabled/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label="Valeur locative">
              <Input value={mesDonnee.locativeValue} disabled/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Nombre d'employés">
              <Input value={mesDonnee.numberEmploye} disabled/>
            </Form.Item>
          </Col>
        </Row>
      </Form>)}
        </div>  
      </div>
    </div>
  </div>
        </>
    )
}